import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { Button } from '@gruposaltaedu/liv-design-system/components';
import { NgIconsModule } from '@ng-icons/core';
import {
  featherChevronDown,
  featherDownload,
  featherLink2,
  featherShare2,
  featherX
} from '@ng-icons/feather-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { CommonsModule } from '../core/commons';
import {
  AuthenticatedExternalLinkDirective,
  GaLinkCleanerDirective
} from '../core/external-links';
import { UiModule } from '../ui/ui.module';
import { AcademicYearsRequestComponent } from './components/academic-years-filter/academic-years-filter.component';
import { CopyLinkModalComponent } from './components/copy-link-modal/copy-link-modal.component';
import { DropdownSelectComponent } from './components/dropdown-select/dropdown-select.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { LoadingMessageComponent } from './components/loading-message/loading-message.component';
import { LivNewTagComponent } from './components/new-tag/new-tag.component';
import { SerieVideoComponent } from './components/serie-video/serie-video.component';
import { SerieVideoShakaComponent } from './components/serie-video-shaka/serie-video-shaka.component';
import { SeriesFilterComponent } from './components/series-filter/series-filter.component';
import { SurveyModalComponent } from './components/survey-modal/survey-modal.component';
import { VideosOfflineComponent } from './components/videos-offline/videos-offline.component';
import { IfLoadedDirective } from './directives/if-loaded.directive';
import { ImagePreloadDirective } from './directives/image-preload.directive';
import { MediaControlDirective } from './directives/media-control.directive';
import { OverlayDirective } from './directives/overlay.directive';
import { NewTagVisiblePipe } from './pipes/new-tag-visible.pipe';
import { WithLoadingPipe } from './pipes/with-loading.pipe';
import { OnboardingModalComponent } from '../modules/home/components/onboarding-modal/onboarding-modal.component';

@NgModule({
  declarations: [
    OverlayDirective,
    ImagePreloadDirective,
    LoadingMessageComponent,
    CopyLinkModalComponent,
    SerieVideoShakaComponent,
    SerieVideoComponent,
    VideosOfflineComponent,
    AcademicYearsRequestComponent,
    WithLoadingPipe,
    IfLoadedDirective,
    SurveyModalComponent,
    MediaControlDirective,
    OnboardingModalComponent
  ],
  imports: [
    Button,
    CommonModule,
    CommonsModule,
    UiModule,
    RouterModule,
    AngularSvgIconModule,
    GaLinkCleanerDirective,
    AuthenticatedExternalLinkDirective,
    FormsModule,
    TranslatePipe,
    DropdownSelectComponent,
    SeriesFilterComponent,
    NgIconsModule.withIcons({
      featherChevronDown,
      featherShare2,
      featherDownload,
      featherLink2,
      featherX
    }),
    ReactiveFormsModule,
    LivNewTagComponent,
    NewTagVisiblePipe,
    EmptyStateComponent
  ],
  exports: [
    OverlayDirective,
    ImagePreloadDirective,
    LoadingMessageComponent,
    CopyLinkModalComponent,
    SerieVideoShakaComponent,
    SerieVideoComponent,
    DropdownSelectComponent,
    SeriesFilterComponent,
    AcademicYearsRequestComponent,
    WithLoadingPipe,
    IfLoadedDirective,
    AngularSvgIconModule,
    UiModule,
    MediaControlDirective,
    GaLinkCleanerDirective,
    AuthenticatedExternalLinkDirective,
    OnboardingModalComponent,
    LivNewTagComponent,
    NewTagVisiblePipe,
    EmptyStateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
